import { createContext, useContext } from 'react';

// Create context for componentId
export const DynamicGridContext = createContext<string | undefined>(undefined);

export const useDynamicGridContext = () => {
  const context = useContext(DynamicGridContext);
  if (context === undefined) {
    throw new Error('useDynamicGridContext must be used within a DynamicGrid');
  }
  return context;
};
